import React, { useEffect, useState } from 'react';
import Topbar from '../layout/Topbar';
import { useLocation, useNavigate } from 'react-router-dom';
import { Bar, Doughnut, Line } from "react-chartjs-2";
import { useBookStore } from '../../provider/BookStore';
import Navbar from '../layout/Navbar';

import PeriodePicker from '../transactions/PeriodePicker';
import dayjs from '../../utils/dayjs';
import { hitungPeriode, applyWeeklyStart } from '../../utils/periode';
import { deriveStatistik } from '../../utils/statistik';
import { useTransactionStore } from '../../provider/TransactionStore';
import Dompet from './Dompet';
import User from './User';
import Keluar from './Keluar';
import Harian from './Harian';
import Masuk from './Masuk';

const Statistic = () => {

    const bookState = useBookStore();
    const book = bookState.book;

    const navigate = useNavigate();

    // cache transaksi bersama dengan halaman Transaksi —
    // statistik diturunkan (derive) dari raw transaksi, bukan fetch /statistics
    const transStore = useTransactionStore();

    const [debit, setDebit] = useState([]);
    const [kredit, setKredit] = useState([]);
    const [daily, setDaily] = useState([]);
    const [users,setUsers] = useState([]);
    const [pockets,setPockets] = useState([])
    const [titleDate, setTitleDate] = useState('')
    const [date,setDate] = useState(dayjs())
    const [isLoading,setLoading] = useState(false)

    useEffect(() => {
        cekState()

        // set default week start day (harus sama dengan Transaction.js,
        // supaya periode mingguan di statistik konsisten walau halaman ini
        // dibuka langsung tanpa melewati halaman transaksi)
        applyWeeklyStart(book.weekly_start);

        setPeriode(0);
    }, []);

    const cekState = ()=>{
        if (book.id === undefined) {
            navigate('/', { replace: true });
        }
    }

    const getStatistic = async (start,end) => {
        cekState()
        setLoading(true)
        // ambil raw transaksi dari cache bersama (fetch API hanya
        // bila periode ini belum pernah di-fetch), lalu turunkan statistiknya
        const transc = await transStore.getTransactions(book.id, start, end);
        const stat = deriveStatistik(transc, start, end);

        setDebit(stat.category.debit);
        setKredit(stat.category.kredit);
        setDaily(stat.daily);
        setUsers(stat.user);
        setPockets(stat.pocket);

        setLoading(false)
    }

    const setPeriode = (add) => {

        const { start, end, title, date: d } = hitungPeriode(book, date, add);

        if (d) {
            setDate(d);
        }
        setTitleDate(title);

        getStatistic(start, end);
    }

    const handlePeriodePrev = () => {
        console.log('previous')
        setPeriode(-1)
    }
    const handlePeriodeNext = () => {
        console.log('next')
        setPeriode(1)
    }

    

    

    return (
        <div>
            <Topbar
                title={book.title}
                back={() => navigate('/')}
                isLoading={isLoading}
            />
            <div className='container p-5'>
                <div className="columns is-centered">
                    <div className="column is-5-widescreen is-6-desktop is-7-tablet">

                        <PeriodePicker
                            periode={book.display}
                            periodeTitle={titleDate}
                            onPrev={handlePeriodePrev}
                            onNext={handlePeriodeNext}
                        />

                        <Masuk data={debit} />

                        <Keluar data={kredit} />

                        <Dompet data={pockets} />

                        <User data={users} />

                        <Harian data={daily} />

                    </div>
                </div>
            </div>
            <Navbar />
        </div>
    )
}

export default Statistic
